import { useEffect, useState } from 'react'

import { Button, InputAdornment } from '@material-ui/core'
import { AttachMoney, Print } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ContentWithOutSubTabs from 'Components/UI/Molecules/ContentWithOutSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { printPDF } from 'Helpers'
import { interfaces } from 'service/interfaces'

import AddItem from './Add'

const Expenses = ({ data, edit, setRender, render, dataBefore, setData, closeCancel }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [formEdit, setFormEdit] = useState(data.gastos)
  // const [selectedRow, setSelectedRow] = useState(null)
  const createDismissableSnackbar = useCustomSnackbar()
  const [tab, setTab] = useState(0)

  // const {
  //   state: paymentDetail,
  //   setOpen: setOpenPaymentDetail,
  //   setClose: setClosePaymentDetail,
  // } = SetState()

  const { state: add, setOpen: openAdd, setClose: closeAdd } = SetState()

  const classes = useStyles()

  const Fields = () => {
    return [
      {
        label: 'Total',
        class: 'textfield',
        value: parseFloat(data.gastoTotal),
        sm: 12,
        xs: 12,
        disabled: true,
        size: 'small',
        type: 'number',
        inputProps: {
          startAdornment: (
            <InputAdornment position="start">
              <AttachMoney />
            </InputAdornment>
          ),
        },
      },
    ]
  }

  async function cajaInfo(id) {
    await interfaces.salesCaja.infoOneCaja(id, data.cajaInfo.origen).then((res) => {
      setData((prevData) => ({
        ...prevData,
        gastos: res.data.gastos,
        gastoTotal: res.data.gastoTotal,
      }))
      setFormEdit(res.data.gastos)
    })
  }

  useEffect(() => {
    const id = data.cajaInfo.id
    cajaInfo(id)
    // eslint-disable-next-line
  }, [formEdit?.length, data.cajaInfo.id])

  const print = async () => {
    setIsLoading(true)
    const [dia, mes, año] = data.cajaInfo.fecha.split('/')
    const fechaFormateada = `${año}-${mes}-${dia}`
    const body = {
      empresa: data.cajaInfo.origen,
      sucursal: data.cajaInfo.sucursal,
      fecha: fechaFormateada,
    }
    await interfaces.salesCaja
      .printGastos(body)
      .then((res) => {
        printPDF(res, 500, 800).print()
        createDismissableSnackbar('Caja impresa con éxito!', {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal', {
          variant: 'error',
        })
      })
    closeCancel()
    setIsLoading(false)
  }

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            <div
              style={{
                display: 'flex',
                margin: '2rem',
                cursor: edit ? 'pointer' : '',
                overflow: 'scroll',
              }}
            >
              <BasicTable
                col={[
                  { title: 'Nombre/Razón social', style: { width: '100px' } },
                  { title: 'Descripción', style: { width: '80px' } },
                  { title: 'Nº factura', style: { width: '80px' } },
                  { title: 'Medio de pago', style: { width: '80px' } },
                  { title: 'Importe', style: { width: '80px' } },
                  { title: '', style: { display: 'none' } },
                ]}
                size="small"
                rows={formEdit?.map((row) => {
                  return {
                    nombre: row.nombre,
                    descripcion: row.descripcion,
                    factura: row.factura,
                    tipo: row.tipo,
                    importe: `$${row.importe}`,
                    id: row.id,
                  }
                })}
                // onClickRow={permissions.allowEditMin ? () => {} : onClickRow}
              />
              <div className={classes.buttonsHome}>
                <Button
                  onClick={openAdd}
                  disabled={dataBefore.data.permissions.ECO.addGastos ? !edit : true}
                  color="primary"
                  variant="contained"
                  size="large"
                  style={{
                    marginLeft: '1rem',
                    height: '40px',
                  }}
                >
                  <AddIcon />
                </Button>

                <Button
                  onClick={print}
                  variant="contained"
                  size="large"
                  style={{
                    marginLeft: '1rem',
                    marginRight: '1rem',
                    height: '40px',
                  }}
                >
                  <Print />
                </Button>

                <InputsWithoutValidate
                  key={data.cajaInfo ? data.cajaInfo.id : 'empty'}
                  fields={Fields()}
                  spacing={2}
                  justifyContent="flex-start"
                />
              </div>
            </div>
          </>
        )
      default:
        break
    }
  }

  return (
    <>
      <ContentWithOutSubTabs value={tab} setValue={setTab} children={renderTabs(tab)} />

      {add.suspense && (
        <AddItem
          open={openAdd}
          handleClose={closeAdd}
          render={render}
          setRender={setRender}
          dataInfo={data}
          setRows={setFormEdit}
          isLoading={isLoading}
        />
      )}

      {/* <DialogComponent
        open={paymentDetail.open}
        title="Editar medio de pago"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        handleclose={setClosePaymentDetail}
        widthLarge="500px"
        children={
          selectedRow ? (
            <InputsWithoutValidate
              fields={editFields(selectedRow, handleChangeItem, dataBefore.data)}
              spacing={2}
            />
          ) : null
        }
        actions={
          <CancelConfirmButtons
            disabledSubmit={isLoading || isSubmitDisabled}
            disabledCancel={isLoading}
            isLoading={isLoading}
            onClickSubmit={editItem}
            onClickCancel={setClosePaymentDetail}
          />
        }
      /> */}
    </>
  )
}

export default Expenses
